module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_2500_Active@1x-67e657f8a042f71cbd34ddc8428f5538.png";